export default "__VITE_ASSET__Quixo8gN__"